/**
 * Type guard: true if `n` is a finite number (excludes NaN and ±Infinity).
 */
export function isFiniteNumber(n: unknown): n is number {
  return typeof n === "number" && Number.isFinite(n);
}

/**
 * Coerces a value to a finite number. Returns `fallback` (default 0) for NaN or ±Infinity.
 */
export function toFiniteNumber(val: unknown, fallback = 0): number {
  const n = Number(val);
  return Number.isFinite(n) ? n : fallback;
}

/**
 * Coerces a value to a non-negative number. Returns 0 for NaN, Infinity, or negative values.
 */
export function toNonNegativeNumber(val: unknown): number {
  const n = Number(val);
  return Number.isFinite(n) && n >= 0 ? n : 0;
}

/**
 * Clamps a value between `min` and `max` (inclusive).
 */
export function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}

/**
 * Floors a number to a specified number of decimal places.
 */
export function floorToDecimals(value: number, decimals: number): number {
  const factor = 10 ** decimals;
  return Math.floor(value * factor) / factor;
}
